import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { api, ArticleDetail } from "../utils/api";

const Article: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [article, setArticle] = useState<ArticleDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchArticle = async () => {
      if (!slug) {
        setError("Article slug not found");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const data = await api.getArticleBySlug(slug);
        setArticle(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [slug]);

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="wrapper">
        <div className="content-page">
          <article className="article-detail">
            <Link to="/articles" className="back-link">
              ← Back to Articles
            </Link>
            <p>Loading article...</p>
          </article>
        </div>
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="wrapper">
        <div className="content-page">
          <article className="article-detail">
            <Link to="/articles" className="back-link">
              ← Back to Articles
            </Link>
            <p>Error loading article: {error || "Article not found"}</p>
          </article>
        </div>
      </div>
    );
  }

  return (
    <div className="wrapper">
      <div className="content-page">
        <article className="article-detail">
          <Link to="/articles" className="back-link">
            ← Back to Articles
          </Link>

          <header className="article-header">
            <img
              src={article.imageUrl}
              alt={article.title}
              className="article-hero-image"
            />
            <h1 className="article-title">{article.title}</h1>
            <p className="article-meta">
              Published on {formatDate(article.createdAt)}
            </p>
            <div className="article-tags">
              {article.tags.map((tag) => (
                <span key={tag} className="tag">
                  #{tag}
                </span>
              ))}
            </div>
          </header>

          <div
            className="article-body"
            dangerouslySetInnerHTML={{ __html: article.contentHtml }}
          />
        </article>
      </div>
    </div>
  );
};

export default Article;
